let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a98CY")).then(() => parcelRequire('5mR3i'));